module.exports = __webpack_public_path__ + "static/media/rs-ministrstvo-razvoj-s.791f7b19.webp";